import React, { useRef } from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import Modal from "@/components/Modal";
import CategoryTree from "@/containers/GroupsDevices/Category/CategoryTreeWrapper";
import { useTranslation } from "@/langs/useTranslation";
import { toast } from "@/apis/request";

function DeviceGroupsModal({
  open,
  onConfirm,
  onClose,
  checkedKeys,
  checkStrictly,
  disableRoot,
  showInstallApp,
  dontCheck
}) {
  const { t } = useTranslation();
  // const checked = useRef([]);
  const checked = useRef(checkedKeys);
  const checkedNodes = useRef([]);
  const tree = useRef(null);
  const [unInstall, setUnInstall] = React.useState(false);

  checked.current = checkedKeys;

  const handleConfirm = () => {
    if (!dontCheck && !checked.current.length) {
      toast.info(t({ defaultMessage: "请选择一个门店" }));
      return;
    }

    return onConfirm?.(checked.current, checkedNodes.current, unInstall);
  };

  const handleCheck = (checkedKeys, info) => {
    checked.current = checkedKeys;
    checkedNodes.current = info.checkedNodes;
  };

  return (
    <Modal
      title={t({ defaultMessage: "选择门店" })}
      width={576}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <CategoryTree
        ref={tree}
        showAll={false}
        showSwitch={false}
        collapse={false}
        selectable={false}
        disableRoot={disableRoot}
        checkedKeys={checkedKeys}
        checkStrictly={checkStrictly}
        height={550}
        readOnly
        checkable
        onCheck={handleCheck}
      />
      {showInstallApp && (
        <div style={{ marginBottom: -57 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={unInstall}
                onChange={e => setUnInstall(e.target.checked)}
              />
            }
            label={t({ defaultMessage: "移除后卸载app" })}
          />
        </div>
      )}
    </Modal>
  );
}

const isEqual = (prevProps, nextProps) => {
  if (nextProps.open) {
    return false;
  }
  return nextProps.open === prevProps.open;
};

export default React.memo(DeviceGroupsModal, isEqual);
